import { render, staticRenderFns } from "./LocationEvents.vue?vue&type=template&id=0853c037"
import script from "./LocationEvents.vue?vue&type=script&lang=js"
export * from "./LocationEvents.vue?vue&type=script&lang=js"
import style0 from "./LocationEvents.vue?vue&type=style&index=0&id=0853c037&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports